import { render, staticRenderFns } from "./CompanyIntro.vue?vue&type=template&id=a22b94ce&scoped=true&"
import script from "./CompanyIntro.vue?vue&type=script&lang=js&"
export * from "./CompanyIntro.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntro.vue?vue&type=style&index=0&id=a22b94ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22b94ce",
  null
  
)

export default component.exports